module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAT1JREFUOBGdUsFRw0AMXNn+5JcS3EFuhjxCXtcB0IE7oARKgBLoAHdg8+KRz1ECFWC/+CQcK2PfyBnyMJrRaCXtynfyAaO5nS+v9r6e8ktxe+1b5U59oSgIsJkKC2MoENFS1C0UDvQI6MeB7c57EWG+zA5vzWsxSDI0kUf5h0lmRRzxHiN6+ofWNZ7hXjlWkwaw0Z2A6hThSGh1EC9VqSuGoNGecpQ7DUkDuIz1VCRZ8WfKidmveN+yiHiy3N8djMw84gEZPL8aOKSkP2qLglJjFNwz2TBPNhsggtuhI/AjwyUmQeqbYrqCqS2C+hJrHulmkWokc7m1uL13xbdZoJnEO1eacifPGs/tmKGz+5j1nfPrYoUXLR6/cBdC280IY3JxB/kKnifo1RX/Jdba7C9YEh9NyDE8Kii2PYt/ALYTZP5A38SSAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/menu/Mask Group 155.png
// module id = 1262
// module chunks = 0